import { render } from "./Synology.vue?vue&type=template&id=63f0db75"
import script from "./Synology.vue?vue&type=script&lang=ts"
export * from "./Synology.vue?vue&type=script&lang=ts"
script.render = render

export default script